import { IdsInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const activateHostFamilies = (ids: number[]) => {
  return restApiClient
    .url(constructApiUrl(API.hostFamilies.activate.url, null))
    .patch<never, IdsInput>({ ids })
}
